import { render } from "./MfAddFile.vue?vue&type=template&id=2ca51cf4&scoped=true"
import script from "./MfAddFile.vue?vue&type=script&lang=js"
export * from "./MfAddFile.vue?vue&type=script&lang=js"

import "./MfAddFile.vue?vue&type=style&index=0&id=2ca51cf4&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ca51cf4"]])

export default __exports__